import { Match } from "@/models";
import { MutationTree } from "vuex";
import { MatchState } from ".";

export const MatchMutationTypes = {
  SetMatch: "SET_MATCH"
};

export const mutations: MutationTree<MatchState> = {
  [MatchMutationTypes.SetMatch](state: MatchState, payload: Match) {
    state.match = {
      ...state.match,
      ...payload
    };
  }
};
